module.exports = __webpack_public_path__ + "assets/img/sidemenu-item01.bc16ac5c.svg";